module.exports = __webpack_public_path__ + "static/media/ft.76c7641e.jpg";